export class SettingsIdReq{
    settingsId?:number

    constructor(settingsId?: number){
        this.settingsId = settingsId
    }
}